export const EASY_EDIT_PLAN = 'Easy Edit Plan';
export const PREDICTIVE_ORDER = 'Predictive Order';
export const REPLENISH = 'Replenish';
export const RESIDENTAL = 'Residental';
export const COMMERCIAL = 'Commercial';
